module.exports = __webpack_public_path__ + "img/objective1.b9181aa9.jpg";